import type { PlacementPayload } from "./types";

const KEY = "posterly-placement-queue";

export interface QueuedPlacement {
  id: string;
  payload: PlacementPayload;
  queuedAt: string;
}

export function readQueue(): QueuedPlacement[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "[]");
  } catch {
    return [];
  }
}

export function queuePlacement(payload: PlacementPayload) {
  const next = [...readQueue(), { id: crypto.randomUUID(), payload, queuedAt: new Date().toISOString() }];
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event("posterly-queue"));
  return next;
}

export function removeQueuedPlacement(id: string) {
  const next = readQueue().filter((item) => item.id !== id);
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event("posterly-queue"));
  return next;
}

export async function flushQueue(save: (payload: PlacementPayload) => Promise<unknown>) {
  const items = readQueue();
  for (const item of items) {
    await save(item.payload);
    removeQueuedPlacement(item.id);
  }
  return readQueue();
}
